export const contactInfo = {
  phone: '+92 (332) 771-0655',
  phoneHref: 'tel:+923327710655',
  whatsapp: '+92 (332) 771-0655',
  whatsappHref: 'https://wa.me/923327710655',
  email: 'herculeslifesciences@gmail.com',
  emailHref: 'mailto:herculeslifesciences@gmail.com',
  address: {
    city: 'Multan',
    country: 'Pakistan'
  },
  businessHours: {
    days: 'Mon – Sat',
    hours: '9:00 AM – 6:00 PM'
  }
};
